import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors, showNotification } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import ListPage from '@/mixins/list-page'
import { MemberModel, MembersOrderBy } from '@/interfaces/member'
import { exportMembersList, findMembers } from './gql'
import MemberDialog from './script-dialog'
import { TypedGqlError } from '@/interfaces/error'
import { SnackType } from '@/interfaces/snack'
import { downloadBase64 } from '@/helpers/base64-to-file'

@Component({
  components: {
    AppBreadcrumbs,
    AppCheckbox,
    AppRefreshAndExport,
    AppDialog,
    AppSimpleTextField,
    AppSimpleSelector,
    AppDatePicker,
    AppSearchBtn,
    AppSimpleDistrictSelector,
    AppTextarea
  }
})

export default class MemberList extends mixins(MemberDialog, ListPage) {
  @State(state => state.page.MemberList) cache!: string

  breadcrumbs: Breadcrumb[] = [
    {
      text: '会员管理'
    },
    {
      text: '会员'
    }
  ]

  options = {
    sortBy: ['createdAt'],
    page: 1,
    itemsPerPage: 10,
    sortDesc: [true]
  }

  filter = {
    nickname: '',
    uniqueId: ''
  }

  totalNum = 0
  loading = false

  disableConfirm = false

  headers = [
    { text: 'ID', value: 'id' },
    { text: '头像', value: 'profilePhtoto' },
    { text: '昵称', value: 'nickname' },
    { text: '识别 ID', value: 'uniqueId' },
    { text: '创建时间', value: 'createdAt' },
    { text: '更新时间', value: 'updatedAt' },
    { text: '操作', value: 'actions', sortable: false, align: 'end' }
  ]

  disabledActions = true

  members: MemberModel[] = []

  selectedMembers = []

  @Watch('options', { deep: true })
  onOptionsChanged () {
    this.getMembers()
  }

  mounted () {
    this.onResize()
    this.restorePage(this.cache)
    this.getMembers()
  }

  // 刷新
  async refreshList () {
    this.clearFilter()
    this.getMembers()
  }

  async getMembers () {
    const { sortBy, page, itemsPerPage, sortDesc } = this.options
    const { nickname, uniqueId } = this.filter
    const by = MembersOrderBy[sortBy[0] || 'realname']
    const asc = !sortDesc[0] || false

    this.loading = true
    const order = { by, asc }
    const paging = {
      skip: itemsPerPage * (page - 1),
      take: itemsPerPage
    }
    const where = {
      nickname: nickname || null,
      uniqueId: uniqueId || null
    }
    const result = await this.queryMembersRequest(order, paging, where)

    if (result) {
      this.members = result.members
      this.totalNum = result.paging.totalCount
    }
    this.loading = false
    this.storePage()
  }

  async queryMembersRequest (order: any, paging: any, where: any) {
    try {
      const result = await this.$apollo.query({
        query: findMembers,
        variables: {
          order,
          paging,
          where
        }
      })
      return result.data.findMembers
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 搜索
  async filterQuerySubmit () {
    await this.getMembers()
  }

  async deleteConfirm () {
    const { $R, members, targetMember } = this
    await this.deleteRequest()
    const index = $R.findIndex((member: MemberModel) => member.id === (targetMember ?? {}).id)(members)
    if (index !== -1) {
      this.members = $R.remove(index, 1)(members)
    }
    this.totalNum -= 1
  }

  // 详情
  routeToDetail (item: MemberModel) {
    this.$router.push({
      name: 'MemberDetail',
      params: {
        id: item.id + ''
      }
    })
  }

  clearFilter () {
    this.filter = {
      nickname: '',
      uniqueId: ''
    }
  }

  async exportHandler () {
    showNotification({
      msg: '即将开始下载...',
      type: SnackType.Info
    })
    const { sortBy, sortDesc } = this.options
    const { nickname, uniqueId } = this.filter
    const by = MembersOrderBy[sortBy[0] || 'createdAt']
    const asc = !sortDesc[0] || false
    this.loading = true
    const order = { by, asc }
    const where = {
      nickname: nickname || null,
      uniqueId: uniqueId || null
    }
    try {
      const result = await this.$apollo.query({
        query: exportMembersList,
        variables: {
          order,
          where
        }
      })
      if (result.data) {
        const { fileName, contentB64 } = result.data.exportMembersList
        downloadBase64(contentB64, fileName)
      }
      this.loading = false
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
